import { render } from "./MessageDock.vue?vue&type=template&id=cb2618f2&scoped=true"
import script from "./MessageDock.vue?vue&type=script&lang=js"
export * from "./MessageDock.vue?vue&type=script&lang=js"

import "./MessageDock.vue?vue&type=style&index=0&id=cb2618f2&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb2618f2"]])

export default __exports__